import { useMemo } from 'react';
import type { PrescriptionAssistantToolDetails } from '../components/PrescriptionAssistantTool/PrescriptionAssistantTool.types';
import type { PatientDetailsContent } from './usePatientDetailsContent';

export const usePrescriptionAssistantToolDetails = ({
  patientDetails
}: {
  patientDetails: PatientDetailsContent;
}): PrescriptionAssistantToolDetails => {
  const prescriptionDetails = useMemo(
    () => ({
      doctor: {
        ...patientDetails.doctor?.DoctorUser,
        clinic: patientDetails.doctor?.DoctorUser?.clinic ?? '',
        address: patientDetails.doctor?.DoctorUser?.address ?? ''
      },
      patient: patientDetails.patient,
      prescriberNumber: patientDetails.doctor?.prescriber_number,
      doctorId: patientDetails.doctor?.id,
      patientId: String(patientDetails.patient?.id ?? 0)
    }),
    [patientDetails]
  );

  return prescriptionDetails;
};
